import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-46f89f4d")

_pushScopeId("data-v-46f89f4d")
const _hoisted_1 = { class: "aj-wrap" }
const _hoisted_2 = { class: "aj-header flex justify-center align-items-center" }
const _hoisted_3 = { style: {"width":"378px"} }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", null, "下一步", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("span", null, "预览", -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("span", null, "完成", -1)
const _hoisted_7 = { class: "aj-body flex justify-center" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", null, "返回后未保存信息将会丢失，是否确认退出？", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ArrowLeftOutlined = _resolveComponent("ArrowLeftOutlined")
  const _component_a_step = _resolveComponent("a-step")
  const _component_a_steps = _resolveComponent("a-steps")
  const _component_FileSearchOutlined = _resolveComponent("FileSearchOutlined")
  const _component_CheckCircleOutlined = _resolveComponent("CheckCircleOutlined")
  const _component_JobBasicInfoVue = _resolveComponent("JobBasicInfoVue")
  const _component_JobAnalysisVue = _resolveComponent("JobAnalysisVue")
  const _component_a_modal = _resolveComponent("a-modal")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: "aj-back",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.modalBack = true))
      }, [
        _createVNode(_component_ArrowLeftOutlined)
      ]),
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_a_steps, {
          onChange: _ctx.changeStep,
          current: _ctx.currentStep,
          size: "small"
        }, {
          default: _withId(() => [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.steps, (step) => {
              return (_openBlock(), _createBlock(_component_a_step, {
                key: step.title,
                status: step.status,
                title: step.title
              }, null, 8, ["status", "title"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["onChange", "current"])
      ]),
      (_ctx.currentStep===0)
        ? (_openBlock(), _createBlock("div", {
            key: 0,
            class: "aj-next",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleNext && _ctx.handleNext(...args)))
          }, [
            _hoisted_4
          ]))
        : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
            _createVNode("div", {
              class: "aj-preview",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleViewClick && _ctx.handleViewClick(...args)))
            }, [
              _createVNode(_component_FileSearchOutlined, { style: {"margin-right":"9px"} }),
              _hoisted_5
            ]),
            _createVNode("div", {
              class: ["aj-complete", {"aj-disabled": _ctx.canFinish}],
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleComplete && _ctx.handleComplete(...args))),
              title: `${_ctx.canFinish ? "每个模块至少一个题目" : ""}`
            }, [
              _createVNode(_component_CheckCircleOutlined, { style: {"margin-right":"9px"} }),
              _hoisted_6
            ], 10, ["title"])
          ], 64))
    ]),
    _createVNode("div", _hoisted_7, [
      (_ctx.currentStep===0)
        ? (_openBlock(), _createBlock(_component_JobBasicInfoVue, {
            key: 0,
            ref: "info"
          }, null, 512))
        : (_openBlock(), _createBlock(_component_JobAnalysisVue, {
            key: 1,
            ref: "analysis",
            onModuleChange: _ctx.moduleChange
          }, null, 8, ["onModuleChange"]))
    ]),
    _createVNode(_component_a_modal, {
      visible: _ctx.modalBack,
      zIndex: 11000,
      onOnOk: _ctx.goBack,
      onOnCancel: _cache[5] || (_cache[5] = ($event: any) => (_ctx.modalBack=false))
    }, {
      content: _withId(() => [
        _hoisted_8
      ]),
      _: 1
    }, 8, ["visible", "onOnOk"])
  ]))
})